import ApiUser from '../services/ApiUser';
import {
    ACTIVATE_USER_ERROR,
    ACTIVATE_USER_START,
    ACTIVATE_USER_SUCCESS,
    EDIT_USER,
    GET_ME_INFO_ERROR,
    GET_ME_INFO_START,
    GET_ME_INFO_SUCCESS,
    GET_USERS_ERROR,
    GET_USERS_START,
    GET_USERS_SUCCESS,
    GET_ADMINS_ERROR,
    GET_ADMINS_START,
    GET_ADMINS_SUCCESS,
    RESET_USER_PASSWORD_ERROR,
    RESET_USER_PASSWORD_START,
    RESET_USER_PASSWORD_SUCCESS,
    UNDELETE_USER_ERROR,
    UNDELETE_USER_START,
    UNDELETE_USER_SUCCESS,
    UPDATE_USER_ERROR,
    UPDATE_USER_START,
    UPDATE_USER_SUCCESS,
    PAYEE_USER_ERROR,
    PAYEE_USER_START,
    PAYEE_USER_SUCCESS,
    ADMIN_USER_ERROR,
    ADMIN_USER_START,
    ADMIN_USER_SUCCESS,
} from './actionTypes';

export const getMe = () => ({
    async: true,
    errorType: GET_ME_INFO_ERROR,
    promise: () => ApiUser.getMe(),
    startType: GET_ME_INFO_START,
    successType: GET_ME_INFO_SUCCESS,
    type: '',
});

export const getUsers = () => ({
    async: true,
    errorType: GET_USERS_ERROR,
    promise: () => ApiUser.getUsers(),
    startType: GET_USERS_START,
    successType: GET_USERS_SUCCESS,
    type: '',
});

export const getAdmins = () => ({
    async: true,
    errorType: GET_ADMINS_ERROR,
    promise: () => ApiUser.getAdmins(),
    startType: GET_ADMINS_START,
    successType: GET_ADMINS_SUCCESS,
    type: '',
});

export const activateUser = (id) => ({
    async: true,
    errorType: ACTIVATE_USER_ERROR,
    promise: () => ApiUser.activateUser(id),
    startType: ACTIVATE_USER_START,
    successType: ACTIVATE_USER_SUCCESS,
    type: '',
});

export const resetUserPassword = (id) => ({
    async: true,
    errorType: RESET_USER_PASSWORD_ERROR,
    promise: () => ApiUser.resetUserPassword(id),
    startType: RESET_USER_PASSWORD_START,
    successType: RESET_USER_PASSWORD_SUCCESS,
    type: '',
});

export const undeleteUser = (id) => ({
    async: true,
    errorType: UNDELETE_USER_ERROR,
    promise: () => ApiUser.undeleteUser(id),
    startType: UNDELETE_USER_START,
    successType: UNDELETE_USER_SUCCESS,
    type: '',
});

export const updateUser = (id, data) => ({
    async: true,
    errorType: UPDATE_USER_ERROR,
    promise: () => ApiUser.updateUser(id, data),
    startType: UPDATE_USER_START,
    successType: UPDATE_USER_SUCCESS,
    type: '',
});

export const editUser = (name, email, enabled, deleted, paying) => ({
    payload: {
        name,
        email,
        enabled,
        deleted,
        paying
    },
    type: EDIT_USER
});

export const payeeUser = (id) => ({
    async: true,
    errorType: PAYEE_USER_ERROR,
    promise: () => ApiUser.payeeUser(id),
    startType: PAYEE_USER_START,
    successType: PAYEE_USER_SUCCESS,
    type: '',
});

export const adminUser = (id) => ({
    async: true,
    errorType: ADMIN_USER_ERROR,
    promise: () => ApiUser.adminUser(id),
    startType: ADMIN_USER_START,
    successType: ADMIN_USER_SUCCESS,
    type: '',
});



// WEBPACK FOOTER //
// ./src/actions/userActions.js